import { render } from "./EllipsisIcon.vue?vue&type=template&id=2a6093c1"
import script from "./EllipsisIcon.vue?vue&type=script&lang=js"
export * from "./EllipsisIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__